module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAShJREFUSEvtlT1KQ1EQhb9p1MIfFCuroNZqpQgpFcFgYeICbN2BCCLWFq7BNVjYuAEtswVdgGCj1QkDE7joy3svLzeNOPVlvsPcM2eMKZdNuT9ZAZLmgF3g1cy+XHwWgKQNoAscAwvAtZk9TQSQNAscROPtH6O+NbPHRgBJ68Ap0AEWR/zheABJM4nanRrGqAeQ1IoRuNqlGo2HT34DJLWBq6SJG2C1oREKASfAzRgqy57+AyoH+UdHlNrUN9SDq2mVL5qke2AfOI8A6wGePXWrEnAJnMVefAB3wBvwCUweFZLWgAdgOSR/Axdm1o+w82j2+PBoLqrqLJK0AhzFaJ7N7D3tFHF9GFm1lS2ui+RK2kwOznyWgzMC5M7bA16ynswya2W5yWWAAXW3dBn7YR28AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/pos.png
// module id = 225
// module chunks = 1